import { httpClient } from '../httpClient';

export const dataflowTRAApi = {
  listTRAs: (params) =>
    httpClient.get('/dataflow/tra', { params }),

  getTRA: (id) =>
    httpClient.get(`/dataflow/tra/${id}`),

  createTRA: (data) =>
    httpClient.post('/dataflow/tra', data),

  savePhase: (traId, phaseNumber, data) =>
    httpClient.put(`/dataflow/tra/${traId}/phase/${phaseNumber}`, data),

  submitTRA: (traId) =>
    httpClient.post(`/dataflow/tra/${traId}/submit`),

  approveTRA: (traId, data) =>
    httpClient.post(`/dataflow/tra/${traId}/approve`, data),

  rejectTRA: (traId, data) =>
    httpClient.post(`/dataflow/tra/${traId}/reject`, data),

  bulkInitiate: (data) =>
    httpClient.post('/dataflow/tra/bulk-initiate', data),
};
